<template>
    <div id="product-purchase-modal" class="modal-new hidden">
        <svg @click="close" class="btn-close-modal" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
            <path
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            <path d="M0 0h24v24H0z" fill="none" />
        </svg>

        <div class="modal-title-container">
            <span class="title">
                {{ product.name }}
            </span>
        </div>

        <div class="modal-content-container product-box mt-10">
            <div class="product-box--description">
                <span class="label">Description</span>
                <span class="d-block" style="text-align: left; line-height: 1.2">{{ product.description }}</span>
                <a :href="getLink(product)" target="_blank" class="d-block mt-3">
                    <span>Learn More</span>
                </a>
            </div>

            <v-progress-circular v-if="loading"
                                 class="product-box--loading mx-auto mt-10"
                                 indeterminate
                                 color="var(--primary)" size="30" width="3"
            />

            <div v-if="!loading" class="product-box--details">
                <template v-if="isCurrentPlanFree">
                    <span class="product-box--title">{{ productTitle }}</span>

                    <a :href="product.link" target="_blank" class="d-block mt-10 mb-10" style="color: white">What's included in the pack?</a>
                    <span v-if="getProductDiscount(PLAN_LITE.slug + '-no-trial') > 0" class="product-box--original-price">${{ product.price + getProductPrice(PLAN_LITE.slug + '-no-trial') }}</span>
                    <span class="product-box--price">${{ product.price + getProductPrice(PLAN_LITE.slug + '-no-trial') - getProductDiscount(PLAN_LITE.slug + '-no-trial') - getProductDiscount(product.fs_slug) }}</span>
                    <span class="mt-1">${{ product.price + getProductPrice(PLAN_LITE.slug + '-no-trial') - getProductDiscount(PLAN_LITE.slug + '-no-trial') - getProductDiscount(product.fs_slug) }} today, then ${{ getProductPrice(PLAN_LITE.slug + '-no-trial') }} every year</span>
                </template>

                <template v-else>
                    <span class="product-box--title">{{ productTitle }}</span>

                    <a :href="product.link" target="_blank" class="d-block mt-10" style="color: white">What's included in the pack?</a>

                    <span class="product-box--price mt-10">${{ product.price }}</span>
                    <span class="mt-1">One-time purchase</span>
                </template>

                <div class="mt-5">
                    <TermsOfSaleAgreementCheckbox dark @change="termsOfSale = $event" />

                    <v-btn :disabled="!termsOfSale && !user.terms_of_sale_agreement" dark class="modal-btn --primary"
                           @click="purchase">{{ isCurrentPlanFree ? 'Subscribe' : 'Buy Now' }}
                    </v-btn>
                </div>
            </div>

            <div v-if="!loading" class="product-box--disclaimer mt-5">
                <div class="product-box--order-summary mb-5">
                    <span class="d-block mb-1">Order summary</span>
                    <div class="product-box--order-summary-items mt-1">
                        <template v-if="isCurrentPlanFree" >
                            <span>fylm.ai Lite yearly subscription</span>
                            <span>${{ getProductPrice(PLAN_LITE.slug + '-no-trial') }}</span>
                        </template>

                        <span>{{product.name.replace(/-/g, "")}} LUT pack</span>
                        <span>${{product.price}}</span>

                        <template v-if="isCurrentPlanFree && (getProductDiscount(PLAN_LITE.slug + '-no-trial') > 0 || getProductDiscount(product.fs_slug) > 0)">
                            <span>Discount</span>
                            <span>${{ getProductDiscount(PLAN_LITE.slug + '-no-trial') + getProductDiscount(product.fs_slug) }}</span>
                        </template>
                    </div>
                    <div class="product-box--order-summary-items mt-1" style="color: white">
                        <span>TOTAL</span>
                        <span v-if="isCurrentPlanFree">${{ product.price + getProductPrice(PLAN_LITE.slug + '-no-trial') - getProductDiscount(PLAN_LITE.slug + '-no-trial') - getProductDiscount(product.fs_slug) }}</span>
                        <span v-else>${{ product.price }}</span>
                    </div>
                </div>

                <span>* LUT packs will become available in fylm.ai Lite app immediately after completing the purchase</span>
                <span class="mt-1">** All prices are subject to local VAT rate where applicable</span>
            </div>
        </div>

        <div class="buttons-continer --single-item mt-10"></div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import FilenameMixin from "@/mixins/Filename";
import TermsOfSaleAgreementCheckbox from "@/components/app/ui/TermsOfSaleAgreementCheckbox.vue";

export default {
    components: {TermsOfSaleAgreementCheckbox},
    data() {
        return {
            termsOfSale: false,
            loading: false
        }
    },
    async created() {
        this.loading = true;
        await this.$store.dispatch('Products/fetchAllPrices');
        setTimeout(() => {
            this.loading = false;
        }, 1000)
    },
    computed: {
        ...mapState('Products', {
            product: 'selectedProduct',
        }),
        ...mapState("User", ["user", "account"]),
        ...mapState("Plans", ['PLAN_LITE_FREE', 'PLAN_LITE']),
        ...mapGetters("User", ["isCurrentPlanFree"]),
        ...mapGetters("Products", ["getProductPrice", "getProductDiscount"]),

        productTitle() {
            if (this.isCurrentPlanFree) return this.product.name.replace(/-/g, "") + " + fylm.ai Lite";
            else return this.product.name.replace(/-/g, "") + " LUT pack";
        },
    },
    methods: {
        close() {
            localStorage.removeItem('selected_product');
        },

        getLink(product) {
            let link = 'https://lutify.me/products/luts/';

            if (product.fs_slug == 'lut-pack-bundle') link += 'bundle-pack';
            else link += product.fs_slug;

            return link;
        },

        purchase(product, addProduct = true) {
            fastspring.builder.tag({
                action: this.account.plan_id == this.PLAN_LITE_FREE.id ? 'PURCHASE_SUBSCRIPTION' : 'PURCHASE_PRODUCT',
                account_id: this.account.id,
                product_name: this.product.name,
                product_id: this.product.id,
                environment: process.env.NODE_ENV
            });

            fastspring.builder.recognize({
                email: this.user.email,
            });

            const fcsBtn = document.querySelector("#fcs-btn");
            if (this.account.plan_id == this.PLAN_LITE_FREE.id) {
                this.$store.dispatch("Organizations/upgradeToPaidPlan", this.PLAN_LITE.id);
                fcsBtn.setAttribute("data-fsc-item-path-value", this.PLAN_LITE.slug);
                if (addProduct) fastspring.builder.add(this.product.fs_slug)
            } else {
                fcsBtn.setAttribute("data-fsc-item-path-value", this.product.fs_slug);
            }

            fcsBtn.click();

            window.UI.hideModal();
        },
    }
};
</script>

<style lang="scss" scoped>
.modal-new {
    width: 50%;
    padding: 20px 50px 25px;

    .modal-title-container {
        width: 80%;
        overflow-x: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-top: 20px;

        .title {
            font-size: 3rem !important;
            line-height: 1;

            background-image: linear-gradient(90deg,hsla(197,100%,63%,1) 0%,hsla(294,100%,55%,1) 100%);
            -webkit-background-clip: text;
            display: inline-block;
            -webkit-text-fill-color: transparent;
        }
    }


    > .btn-close-modal {
        right: 43px;
        top: 40px;
    }
}

.product-box {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-areas: "left right" "left disclaimer";
    grid-column-gap: 10%;
    &--description {
        grid-area: left;

        .label {
            font-size: 1rem;
            line-height: 2;
            font-weight: bold;
            color: white;
        }
    }

	&--loading {
		grid-area: right;
	}

    &--details {
        grid-area: right;
        display: flex;
        flex-direction: column;
        border: 2px solid var(--color-accent-2);
        border-radius: 10px;
        padding: 20px;
    }

    &--title, &--price {
        font-size: 1.5rem;
        line-height: 1.2;
        font-weight: bold;
        color: white;
    }

	&--original-price {
		line-height: 1.25;
		text-decoration: line-through;
	}

    &--disclaimer {
        grid-area: disclaimer;
        display: flex;
        flex-direction: column;
    }

	&--order-summary {
		hr {
			background-color: #ccc;
			opacity: 0.5;
			height: 1px;
			border: 0;
		}
	}

	&--order-summary-items {
		display: grid;
		grid-template-columns: 1fr auto;
		grid-row-gap: 5px;
	}

    .modal-btn {
        background-image: linear-gradient(50deg,#44C8FF 0%,#E61DFF 100%) !important;
    }
}
</style>
